import {starFilledSvg as Icon__small__starFilledSvg} from '../Icon__small/Icon__small--starFilled.js';

export var starFilled = {
  name: 'starFilled',
  category: 'icon',
  colorable: true,
  svg: Icon__small__starFilledSvg,
};
